import { getErrorTargetId } from '../generic/ValidationErrors';
import { getOperativeSystem } from '../products/utils';
import getEventTargetValue from '../utils/get-event-target-value';
import {
  changeCountrySplit,
  changeQuoteLine,
  changeQuoteLineSelection,
  duplicateQuoteLine,
  removeQuoteLine,
  splitCountrySharesEqually,
} from './actions';
import { connectEditor } from './connect-editor';
import QuoteLineRow from './QuoteLineTable/QuoteLineRow';
import {
  calculateNetClientBudgetExternal,
  calculateWkzBudget,
} from './utils/calculate-derived-values';
import { getOffSiteMinBudgetSpecification } from './utils/offsite-min-budget';

export default connectEditor(
  (
    { quoteLinesById, quoteLinesSelection, quote, productsById },
    { id, index },
  ) => {
    const quoteLine = quoteLinesById[id];
    const quoteLines = quote.quoteLines.map(each => quoteLinesById[each]);
    const product = quoteLine && productsById[quoteLine.productId];
    const isSalesforceQuote = !!quote.salesforceId;

    return {
      model: quoteLine,
      isSelected: quoteLinesSelection[id] ?? false,
      productName: product.name,
      productGroup: product.productGroup,
      productBusiness: product.business,
      productCode: product.code,
      productOperativeSystem: getOperativeSystem(product),
      supportsProductTags: product.supportsProductTags,
      offSiteMinBudgetSpecification: getOffSiteMinBudgetSpecification(
        product.base14DayBudget,
        product.additional14DayBudgetPerCountry,
      ),
      pricingOptions: product.possiblePriceModels.map(priceModel => ({
        label: priceModel,
        value: priceModel,
      })),
      withAdjustedFee: product.adjustedFee,
      withFreeService: product.hasFreeService,
      netClientBudgetExternal: calculateNetClientBudgetExternal(quoteLines),
      wkzBudget: calculateWkzBudget(quoteLines),
      headerDiscountPercent: quote.headerDiscountPercent,
      id: getErrorTargetId('quoteLines', index),
      isSalesforceQuote,
    };
  },
  {
    onChange: event =>
      changeQuoteLine(
        event.target.dataset.quoteLineId,
        event.target.name,
        getEventTargetValue(event.target),
      ),
    onChangeSelection: event =>
      changeQuoteLineSelection(
        event.target.dataset.quoteLineId,
        getEventTargetValue(event.target),
      ),
    onChangeCountrySplit: event =>
      changeCountrySplit(
        event.target.dataset.quoteLineId,
        event.target.dataset.countryCode,
        getEventTargetValue(event.target),
      ),
    onSplitCountrySharesEqually: quoteLineId =>
      splitCountrySharesEqually(quoteLineId),
    onRemove: event =>
      removeQuoteLine(Number.parseInt(event.target.dataset.quoteLineId, 10)),
    onDuplicate: event =>
      duplicateQuoteLine(Number.parseInt(event.target.dataset.quoteLineId, 10)),
  },
)(QuoteLineRow);
